import { useCallback } from 'react';
import { DELETE_JOB_MOBILE_PHOTO_RECORDS } from 'src/graphql/mobile/mutation';
import { useMutation } from 'src/graphql';

export default (params = {}) => {

  const [deleteJobMobilePhotoRecords, { data, error, ...rest }] = useMutation(DELETE_JOB_MOBILE_PHOTO_RECORDS, {
    ...params,
    ignoreErrors: true,
  });

  return useCallback(async (jobId, payload, deletePrimary = false) => {
    return deleteJobMobilePhotoRecords({ variables: { jobId, photoAttachmentIds: payload, deletePrimary } });
  });
};
